import React from 'react';
import classNames from 'classnames';

import './Logo.less';

export class Logo extends React.Component {
    get logoLink() {
        const {
            altText,
            hasSearch,
            image,
            link,
            partnerLogo,
            text,
        } = this.props;
        const className = classNames(
            'site-header-logo__link',
            'flex-item',
            {'has-search': hasSearch},
            {'hidden-xs': hasSearch || !!partnerLogo},
        );

        return (
            <a className={className} href={link} title={text}>
                <img alt={altText} className="site-header-logo__img img-responsive" role="presentation" src={image} />
            </a>
        );
    }

    /* istanbul ignore next */
    get parterLogoLink() {
        if (!this.props.partnerLogo) {
            return null;
        }

        const {image, link, text} = this.props.partnerLogo;

        return (
            <a className="site-header-logo__link has-partner-divider" href={link} title={text}>
                <img alt="partner logo" className="site-header-logo__img" src={image} />
            </a>
        );
    }

    render() {
        return (
            <div className="site-header-logo">
                {this.parterLogoLink}
                {this.logoLink}
            </div>
        );
    }
}
